/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<43b70a36c73db63475b27df375c5d89a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from "relay-runtime";
import type { FragmentRefs } from "relay-runtime";
export type editHomepageQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type editHomepageQuery$data = {
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "QueryError";
      readonly homePageLayout?: {
        readonly data: {
          readonly " $fragmentSpreads": FragmentRefs<"layoutBuilderFragment" | "useLayoutServiceFragment">;
        };
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"globalBrandingSettingsPanelFragment">;
    } | null;
    readonly mediaConfig: {
      readonly " $fragmentSpreads": FragmentRefs<"globalBrandingSettingsPanelMediaConfigFragment">;
    } | null;
  } | null;
  readonly helpLayout: {
    readonly elementTypes: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"elementsCatalogueFragment">;
    }> | null;
    readonly mediaConfig: {
      readonly asapIssuer: string | null;
      readonly mediaCollectionName: string | null;
      readonly mediaToken: string | null;
      readonly mediaUrl: string | null;
    } | null;
  } | null;
};
export type editHomepageQuery = {
  response: editHomepageQuery$data;
  variables: editHomepageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "HelpLayoutSubsectionConfig",
  "kind": "LinkedField",
  "name": "config",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "span",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headingType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v8 = {
  "alias": "headingConfig",
  "args": null,
  "concreteType": "HelpLayoutHeadingAtomicElementConfig",
  "kind": "LinkedField",
  "name": "config",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "horizontalAlignment",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verticalAlignment",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "HelpLayoutAlignmentSettings",
  "kind": "LinkedField",
  "name": "alignment",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "HelpLayoutBackgroundImage",
  "kind": "LinkedField",
  "name": "backgroundImage",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v15 = [
  (v11/*: any*/),
  (v14/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "HelpLayoutVisualConfig",
  "kind": "LinkedField",
  "name": "visualConfig",
  "plural": false,
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useLayoutServiceVisualConfigData",
      "selections": (v15/*: any*/),
      "args": null,
      "argumentDefinitions": ([]/*: any*/)
    }
  ],
  "storageKey": null
},
v17 = {
  "kind": "InlineDataFragmentSpread",
  "name": "useLayoutServiceHeadingElementData",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v8/*: any*/),
        (v16/*: any*/)
      ],
      "type": "HelpLayoutHeadingAtomicElement",
      "abstractKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "adf",
  "storageKey": null
},
v19 = {
  "alias": "paragraphConfig",
  "args": null,
  "concreteType": "HelpLayoutParagraphAtomicElementConfig",
  "kind": "LinkedField",
  "name": "config",
  "plural": false,
  "selections": [
    (v18/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "kind": "InlineDataFragmentSpread",
  "name": "useLayoutServiceParagraphElementData",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v19/*: any*/),
        (v16/*: any*/)
      ],
      "type": "HelpLayoutParagraphAtomicElement",
      "abstractKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "placeHolderText",
  "storageKey": null
},
v22 = {
  "alias": "searchConfig",
  "args": null,
  "concreteType": "HelpLayoutSearchAtomicElementConfig",
  "kind": "LinkedField",
  "name": "config",
  "plural": false,
  "selections": [
    (v21/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "altText",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v26 = [
  (v25/*: any*/)
],
v27 = {
  "kind": "InlineDataFragmentSpread",
  "name": "useLayoutServiceImageElementData",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        (v5/*: any*/),
        {
          "alias": "imageConfig",
          "args": null,
          "concreteType": "HelpLayoutImageAtomicElementConfig",
          "kind": "LinkedField",
          "name": "config",
          "plural": false,
          "selections": [
            (v23/*: any*/),
            (v12/*: any*/),
            (v24/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "HelpLayoutImageAtomicElementData",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": (v26/*: any*/),
          "storageKey": null
        },
        (v16/*: any*/)
      ],
      "type": "HelpLayoutImageAtomicElement",
      "abstractKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v28 = {
  "alias": "linkCardConfig",
  "args": null,
  "kind": "ScalarField",
  "name": "config",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__id",
  "storageKey": null
},
v30 = {
  "kind": "ClientExtension",
  "selections": [
    (v29/*: any*/)
  ]
},
v31 = [
  {
    "kind": "Variable",
    "name": "parentAri",
    "variableName": "helpCenterAri"
  }
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaUrl",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaToken",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaCollectionName",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "asapIssuer",
  "storageKey": null
},
v36 = [
  (v32/*: any*/),
  (v33/*: any*/),
  (v34/*: any*/),
  (v35/*: any*/)
],
v37 = {
  "alias": null,
  "args": (v31/*: any*/),
  "concreteType": "HelpLayoutMediaConfig",
  "kind": "LinkedField",
  "name": "mediaConfig",
  "plural": false,
  "selections": (v36/*: any*/),
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fit",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v41 = {
  "alias": "dataId",
  "args": null,
  "kind": "ScalarField",
  "name": "__id",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "HelpLayoutVisualConfig",
  "kind": "LinkedField",
  "name": "visualConfig",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v43 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpLayoutVisualConfig",
      "kind": "LinkedField",
      "name": "visualConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "HelpLayoutAlignmentSettings",
          "kind": "LinkedField",
          "name": "alignment",
          "plural": false,
          "selections": [
            (v30/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HelpLayoutVisualEntity",
  "abstractKey": "__isHelpLayoutVisualEntity"
},
v44 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "imageConfig",
      "args": null,
      "concreteType": "HelpLayoutImageAtomicElementConfig",
      "kind": "LinkedField",
      "name": "config",
      "plural": false,
      "selections": [
        (v23/*: any*/),
        (v24/*: any*/),
        (v39/*: any*/),
        (v12/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "imageData",
      "args": null,
      "concreteType": "HelpLayoutImageAtomicElementData",
      "kind": "LinkedField",
      "name": "data",
      "plural": false,
      "selections": (v26/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpLayoutAtomicElementType",
      "kind": "LinkedField",
      "name": "elementType",
      "plural": false,
      "selections": [
        (v40/*: any*/),
        {
          "alias": null,
          "args": (v31/*: any*/),
          "concreteType": "HelpLayoutMediaConfig",
          "kind": "LinkedField",
          "name": "mediaConfig",
          "plural": false,
          "selections": [
            (v34/*: any*/),
            (v33/*: any*/),
            (v32/*: any*/),
            (v35/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpLayoutImageAtomicElementConfig",
      "kind": "LinkedField",
      "name": "config",
      "plural": false,
      "selections": [
        (v24/*: any*/),
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": "configId",
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            },
            (v29/*: any*/)
          ]
        },
        (v23/*: any*/),
        (v39/*: any*/)
      ],
      "storageKey": null
    },
    (v38/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpLayoutImageAtomicElementData",
      "kind": "LinkedField",
      "name": "data",
      "plural": false,
      "selections": [
        (v25/*: any*/),
        {
          "kind": "ClientExtension",
          "selections": [
            (v41/*: any*/)
          ]
        }
      ],
      "storageKey": null
    },
    (v42/*: any*/),
    (v43/*: any*/),
    {
      "kind": "ClientExtension",
      "selections": [
        (v29/*: any*/),
        {
          "alias": "elementId",
          "args": null,
          "kind": "ScalarField",
          "name": "__id",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "HelpLayoutImageAtomicElement",
  "abstractKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "HelpLayoutVisualConfig",
  "kind": "LinkedField",
  "name": "visualConfig",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpLayoutAlignmentSettings",
      "kind": "LinkedField",
      "name": "alignment",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        (v10/*: any*/),
        (v30/*: any*/)
      ],
      "storageKey": null
    },
    (v14/*: any*/)
  ],
  "storageKey": null
},
v46 = [
  (v40/*: any*/)
],
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "HelpLayoutAtomicElementType",
  "kind": "LinkedField",
  "name": "elementType",
  "plural": false,
  "selections": (v46/*: any*/),
  "storageKey": null
},
v48 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpLayoutParagraphAtomicElementConfig",
      "kind": "LinkedField",
      "name": "config",
      "plural": false,
      "selections": [
        (v18/*: any*/),
        (v30/*: any*/)
      ],
      "storageKey": null
    },
    (v45/*: any*/),
    (v47/*: any*/),
    (v30/*: any*/),
    (v19/*: any*/)
  ],
  "type": "HelpLayoutParagraphAtomicElement",
  "abstractKey": null
},
v49 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpLayoutHeadingAtomicElementConfig",
      "kind": "LinkedField",
      "name": "config",
      "plural": false,
      "selections": [
        (v7/*: any*/),
        (v6/*: any*/),
        (v30/*: any*/)
      ],
      "storageKey": null
    },
    (v45/*: any*/),
    (v47/*: any*/),
    (v30/*: any*/),
    (v8/*: any*/)
  ],
  "type": "HelpLayoutHeadingAtomicElement",
  "abstractKey": null
},
v50 = {
  "kind": "InlineFragment",
  "selections": [
    (v38/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v51 = [
  (v13/*: any*/),
  (v12/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "editHomepageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HelpCenterHomePageLayout",
                    "kind": "LinkedField",
                    "name": "homePageLayout",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "data",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "args": null,
                                  "kind": "FragmentSpread",
                                  "name": "layoutBuilderFragment"
                                },
                                {
                                  "kind": "InlineDataFragmentSpread",
                                  "name": "useLayoutServiceFragment",
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "HelpLayoutSectionConnection",
                                      "kind": "LinkedField",
                                      "name": "sections",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "HelpLayoutSectionEdge",
                                          "kind": "LinkedField",
                                          "name": "edges",
                                          "plural": true,
                                          "selections": [
                                            {
                                              "alias": null,
                                              "args": null,
                                              "concreteType": "HelpLayoutSection",
                                              "kind": "LinkedField",
                                              "name": "node",
                                              "plural": false,
                                              "selections": [
                                                {
                                                  "alias": null,
                                                  "args": null,
                                                  "concreteType": "HelpLayoutSubsection",
                                                  "kind": "LinkedField",
                                                  "name": "subsections",
                                                  "plural": true,
                                                  "selections": [
                                                    (v4/*: any*/),
                                                    {
                                                      "alias": null,
                                                      "args": null,
                                                      "concreteType": null,
                                                      "kind": "LinkedField",
                                                      "name": "elements",
                                                      "plural": true,
                                                      "selections": [
                                                        (v5/*: any*/),
                                                        (v17/*: any*/),
                                                        (v20/*: any*/),
                                                        {
                                                          "kind": "InlineDataFragmentSpread",
                                                          "name": "useLayoutServiceSearchElementData",
                                                          "selections": [
                                                            {
                                                              "kind": "InlineFragment",
                                                              "selections": [
                                                                (v5/*: any*/),
                                                                (v22/*: any*/)
                                                              ],
                                                              "type": "HelpLayoutSearchAtomicElement",
                                                              "abstractKey": null
                                                            }
                                                          ],
                                                          "args": null,
                                                          "argumentDefinitions": []
                                                        },
                                                        (v27/*: any*/),
                                                        {
                                                          "kind": "InlineDataFragmentSpread",
                                                          "name": "useLayoutServiceLinkCardElementData",
                                                          "selections": [
                                                            {
                                                              "kind": "InlineFragment",
                                                              "selections": [
                                                                (v28/*: any*/),
                                                                {
                                                                  "alias": null,
                                                                  "args": null,
                                                                  "concreteType": null,
                                                                  "kind": "LinkedField",
                                                                  "name": "children",
                                                                  "plural": true,
                                                                  "selections": [
                                                                    (v5/*: any*/),
                                                                    (v17/*: any*/),
                                                                    (v27/*: any*/),
                                                                    (v20/*: any*/)
                                                                  ],
                                                                  "storageKey": null
                                                                }
                                                              ],
                                                              "type": "HelpLayoutLinkCardCompositeElement",
                                                              "abstractKey": null
                                                            }
                                                          ],
                                                          "args": null,
                                                          "argumentDefinitions": []
                                                        }
                                                      ],
                                                      "storageKey": null
                                                    },
                                                    (v16/*: any*/)
                                                  ],
                                                  "storageKey": null
                                                },
                                                (v16/*: any*/)
                                              ],
                                              "storageKey": null
                                            }
                                          ],
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    },
                                    (v30/*: any*/)
                                  ],
                                  "args": null,
                                  "argumentDefinitions": []
                                }
                              ],
                              "type": "HelpLayout",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        "action": "THROW",
                        "path": "helpCenter.helpCenterById.homePageLayout.data"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "globalBrandingSettingsPanelFragment"
                  }
                ],
                "type": "HelpCenter",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "QueryError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "mediaConfig",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "globalBrandingSettingsPanelMediaConfigFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "HelpLayoutQueryApi",
        "kind": "LinkedField",
        "name": "helpLayout",
        "plural": false,
        "selections": [
          (v37/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "elementTypes",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "elementsCatalogueFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "editHomepageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HelpCenterHomePageLayout",
                    "kind": "LinkedField",
                    "name": "homePageLayout",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v38/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "HelpLayoutSectionConnection",
                                "kind": "LinkedField",
                                "name": "sections",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "HelpLayoutSectionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "HelpLayoutSection",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "HelpLayoutSubsection",
                                            "kind": "LinkedField",
                                            "name": "subsections",
                                            "plural": true,
                                            "selections": [
                                              (v4/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "elements",
                                                "plural": true,
                                                "selections": [
                                                  (v5/*: any*/),
                                                  {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isHelpLayoutElement"
                                                  },
                                                  (v44/*: any*/),
                                                  (v48/*: any*/),
                                                  (v49/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": null,
                                                        "kind": "LinkedField",
                                                        "name": "children",
                                                        "plural": true,
                                                        "selections": [
                                                          (v5/*: any*/),
                                                          {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isHelpLayoutAtomicElement"
                                                          },
                                                          (v44/*: any*/),
                                                          (v48/*: any*/),
                                                          (v49/*: any*/),
                                                          (v30/*: any*/),
                                                          (v50/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "HelpLayoutCompositeElementType",
                                                        "kind": "LinkedField",
                                                        "name": "elementType",
                                                        "plural": false,
                                                        "selections": (v46/*: any*/),
                                                        "storageKey": null
                                                      },
                                                      (v28/*: any*/),
                                                      (v30/*: any*/)
                                                    ],
                                                    "type": "HelpLayoutLinkCardCompositeElement",
                                                    "abstractKey": null
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "HelpLayoutSearchAtomicElementConfig",
                                                        "kind": "LinkedField",
                                                        "name": "config",
                                                        "plural": false,
                                                        "selections": [
                                                          (v21/*: any*/),
                                                          (v30/*: any*/)
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v47/*: any*/),
                                                      (v22/*: any*/),
                                                      (v30/*: any*/)
                                                    ],
                                                    "type": "HelpLayoutSearchAtomicElement",
                                                    "abstractKey": null
                                                  },
                                                  (v30/*: any*/),
                                                  (v50/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v38/*: any*/),
                                              (v42/*: any*/),
                                              (v43/*: any*/),
                                              (v30/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "HelpLayoutVisualConfig",
                                            "kind": "LinkedField",
                                            "name": "visualConfig",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "HelpLayoutBackgroundImage",
                                                "kind": "LinkedField",
                                                "name": "backgroundImage",
                                                "plural": false,
                                                "selections": (v51/*: any*/),
                                                "storageKey": null
                                              },
                                              (v11/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v38/*: any*/),
                                          {
                                            "kind": "ClientExtension",
                                            "selections": [
                                              (v41/*: any*/),
                                              (v29/*: any*/)
                                            ]
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v30/*: any*/)
                            ],
                            "type": "HelpLayout",
                            "abstractKey": null
                          },
                          (v50/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "primary",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": (v51/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "HelpCenter",
                "abstractKey": null
              },
              (v50/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "mediaConfig",
            "plural": false,
            "selections": (v36/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "HelpLayoutQueryApi",
        "kind": "LinkedField",
        "name": "helpLayout",
        "plural": false,
        "selections": [
          (v37/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "elementTypes",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isHelpLayoutElementType"
              },
              (v40/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "atomicKey",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v31/*: any*/),
                    "concreteType": "HelpLayoutMediaConfig",
                    "kind": "LinkedField",
                    "name": "mediaConfig",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v34/*: any*/),
                      (v33/*: any*/),
                      (v32/*: any*/),
                      (v35/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "HelpLayoutAtomicElementType",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "compositeKey",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  }
                ],
                "type": "HelpLayoutCompositeElementType",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8ca7bcd897214165c1e7bd89167834b6",
    "id": null,
    "metadata": {},
    "name": "editHomepageQuery",
    "operationKind": "query",
    "text": "query editHomepageQuery(\n  $helpCenterAri: ID!\n  $cloudId: ID!\n) {\n  helpCenter(cloudId: $cloudId) {\n    helpCenterById(helpCenterAri: $helpCenterAri) @optIn(to: [\"HelpCenterAggBeta\"]) {\n      __typename\n      ... on HelpCenter {\n        homePageLayout @optIn(to: [\"HelpCenterLayoutTest\"]) {\n          data {\n            __typename\n            ... on HelpLayout {\n              ...layoutBuilderFragment\n              ...useLayoutServiceFragment\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n        ...globalBrandingSettingsPanelFragment\n      }\n      ... on QueryError {\n        __typename\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    mediaConfig(helpCenterAri: $helpCenterAri) {\n      ...globalBrandingSettingsPanelMediaConfigFragment\n    }\n  }\n  helpLayout(cloudId: $cloudId) @optIn(to: \"HelpLayoutExperimentalSchema\") {\n    mediaConfig(parentAri: $helpCenterAri) {\n      mediaUrl\n      mediaToken\n      mediaCollectionName\n      asapIssuer\n    }\n    elementTypes {\n      __typename\n      ...elementsCatalogueFragment\n    }\n  }\n}\n\nfragment alignmentSettingsContextFragment on HelpLayoutVisualConfig {\n  alignment {\n    horizontalAlignment\n    verticalAlignment\n  }\n}\n\nfragment alignmentSettingsContextHookFragment on HelpLayoutVisualConfig {\n  alignment {\n    horizontalAlignment\n    verticalAlignment\n  }\n}\n\nfragment alignmentSettingsUiFragment on HelpLayoutVisualConfig {\n  alignment {\n    horizontalAlignment\n  }\n}\n\nfragment atomicElementFragment on HelpLayoutAtomicElement {\n  __isHelpLayoutAtomicElement: __typename\n  __typename\n  ... on HelpLayoutImageAtomicElement {\n    ...imageFragment\n    elementType {\n      displayName\n    }\n  }\n  ... on HelpLayoutParagraphAtomicElement {\n    ...paragraphFragment\n    ...paragraphEditorFragment\n    elementType {\n      displayName\n    }\n  }\n  ... on HelpLayoutHeadingAtomicElement {\n    ...headingFragment\n    ...headingEditorFragment\n    elementType {\n      displayName\n    }\n  }\n}\n\nfragment backgroundImageUploaderFragment on HelpLayoutVisualConfig {\n  backgroundImage {\n    url\n  }\n}\n\nfragment brandColorPickerFragment on HelpCenterBrandingColors {\n  primary\n}\n\nfragment brandLogoUploaderFragment on HelpCenterLogo {\n  url\n}\n\nfragment brandLogoUploaderMediaConfigFragment on HelpCenterMediaConfig {\n  mediaUrl\n  mediaToken\n  mediaCollectionName\n  asapIssuer\n}\n\nfragment elementCardFragment on HelpLayoutElementType {\n  __isHelpLayoutElementType: __typename\n  displayName\n  __typename\n  ... on HelpLayoutAtomicElementType {\n    atomicKey: key\n    mediaConfig(parentAri: $helpCenterAri) {\n      __typename\n      mediaCollectionName\n      mediaToken\n      mediaUrl\n      asapIssuer\n    }\n  }\n  ... on HelpLayoutCompositeElementType {\n    compositeKey: key\n  }\n}\n\nfragment elementFragment on HelpLayoutElement {\n  __isHelpLayoutElement: __typename\n  __typename\n  ... on HelpLayoutImageAtomicElement {\n    ...imageFragment\n    elementType {\n      displayName\n    }\n  }\n  ... on HelpLayoutParagraphAtomicElement {\n    ...paragraphFragment\n    ...paragraphEditorFragment\n    elementType {\n      displayName\n    }\n  }\n  ... on HelpLayoutHeadingAtomicElement {\n    ...headingFragment\n    ...headingEditorFragment\n    elementType {\n      displayName\n    }\n  }\n  ... on HelpLayoutLinkCardCompositeElement {\n    ...linkCardEditorFragment\n    ...linkCardFragment\n    elementType {\n      displayName\n    }\n  }\n  ... on HelpLayoutSearchAtomicElement {\n    ...searchViewFragment\n    ...searchEditorFragment\n    elementType {\n      displayName\n    }\n  }\n}\n\nfragment elementsCatalogueFragment on HelpLayoutElementType {\n  __isHelpLayoutElementType: __typename\n  ...elementCardFragment\n}\n\nfragment globalBrandingSettingsPanelFragment on HelpCenter {\n  helpCenterBranding @optIn(to: [\"HelpCenterBrandingTest\"]) {\n    colors {\n      ...brandColorPickerFragment\n      primary\n    }\n    logo {\n      ...brandLogoUploaderFragment\n      url\n      fileId\n    }\n  }\n}\n\nfragment globalBrandingSettingsPanelMediaConfigFragment on HelpCenterMediaConfig {\n  ...brandLogoUploaderMediaConfigFragment\n}\n\nfragment headingEditorFragment on HelpLayoutHeadingAtomicElement {\n  config {\n    text\n    headingType\n  }\n  elementType {\n    displayName\n  }\n  visualConfig {\n    ...alignmentSettingsContextFragment\n    ...alignmentSettingsContextHookFragment\n    ...alignmentSettingsUiFragment\n  }\n}\n\nfragment headingFragment on HelpLayoutHeadingAtomicElement {\n  config {\n    text\n    headingType\n  }\n  visualConfig {\n    ...alignmentSettingsContextFragment\n    ...alignmentSettingsContextHookFragment\n  }\n}\n\nfragment imageAltTextFragment on HelpLayoutImageAtomicElement {\n  config {\n    altText\n  }\n}\n\nfragment imageEditorFragment on HelpLayoutImageAtomicElement {\n  id\n  ...imageAltTextFragment\n  ...imageSizingFragment\n  ...imageUploaderFragment\n  data {\n    imageUrl\n  }\n  elementType {\n    displayName\n  }\n  ... on HelpLayoutVisualEntity {\n    __isHelpLayoutVisualEntity: __typename\n    visualConfig {\n      ...alignmentSettingsUiFragment\n    }\n  }\n}\n\nfragment imageFragment on HelpLayoutImageAtomicElement {\n  imageConfig: config {\n    altText\n    size\n    fit\n  }\n  imageData: data {\n    imageUrl\n  }\n  elementType {\n    displayName\n    mediaConfig(parentAri: $helpCenterAri) {\n      mediaCollectionName\n      mediaToken\n      mediaUrl\n      asapIssuer\n    }\n  }\n  ... on HelpLayoutVisualEntity {\n    __isHelpLayoutVisualEntity: __typename\n    visualConfig {\n      ...alignmentSettingsContextFragment\n      ...alignmentSettingsContextHookFragment\n    }\n  }\n  ...imageResizerFragment\n  ...imageEditorFragment\n}\n\nfragment imageResizerFragment on HelpLayoutImageAtomicElement {\n  config {\n    size\n  }\n}\n\nfragment imageSizingFragment on HelpLayoutImageAtomicElement {\n  config {\n    size\n    fit\n  }\n}\n\nfragment imageUploaderFragment on HelpLayoutImageAtomicElement {\n  data {\n    imageUrl\n  }\n  config {\n    altText\n  }\n  elementType {\n    mediaConfig(parentAri: $helpCenterAri) {\n      mediaUrl\n      mediaToken\n      mediaCollectionName\n      asapIssuer\n    }\n  }\n}\n\nfragment layoutBuilderFragment on HelpLayout {\n  id\n  sections {\n    edges {\n      node {\n        ...sectionFragment\n        id\n      }\n    }\n  }\n}\n\nfragment linkCardEditorFragment on HelpLayoutLinkCardCompositeElement {\n  children {\n    __typename\n    ...atomicElementFragment\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  elementType {\n    displayName\n  }\n  linkCardConfig: config\n}\n\nfragment linkCardFragment on HelpLayoutLinkCardCompositeElement {\n  children {\n    __typename\n    ...atomicElementFragment\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  linkCardConfig: config\n}\n\nfragment paragraphEditorFragment on HelpLayoutParagraphAtomicElement {\n  config {\n    adf\n  }\n  elementType {\n    displayName\n  }\n  visualConfig {\n    ...alignmentSettingsContextFragment\n    ...alignmentSettingsUiFragment\n    ...alignmentSettingsContextHookFragment\n  }\n}\n\nfragment paragraphFragment on HelpLayoutParagraphAtomicElement {\n  config {\n    adf\n  }\n  visualConfig {\n    ...alignmentSettingsContextFragment\n    ...alignmentSettingsUiFragment\n    ...alignmentSettingsContextHookFragment\n  }\n}\n\nfragment searchEditorFragment on HelpLayoutSearchAtomicElement {\n  config {\n    placeHolderText\n  }\n  elementType {\n    displayName\n  }\n}\n\nfragment searchViewFragment on HelpLayoutSearchAtomicElement {\n  config {\n    placeHolderText\n  }\n}\n\nfragment sectionEditorFragment on HelpLayoutSection {\n  visualConfig {\n    ...backgroundImageUploaderFragment\n  }\n}\n\nfragment sectionFragment on HelpLayoutSection {\n  subsections {\n    ...subsectionFragment\n    id\n  }\n  visualConfig {\n    backgroundImage {\n      url\n    }\n  }\n  ...sectionEditorFragment\n}\n\nfragment subsectionFragment on HelpLayoutSubsection {\n  config {\n    span\n  }\n  elements {\n    __typename\n    ...elementFragment\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ... on HelpLayoutVisualEntity {\n    __isHelpLayoutVisualEntity: __typename\n    visualConfig {\n      ...alignmentSettingsContextFragment\n      ...alignmentSettingsUiFragment\n      ...alignmentSettingsContextHookFragment\n    }\n  }\n}\n\nfragment useLayoutServiceFragment on HelpLayout {\n  sections {\n    edges {\n      node {\n        subsections {\n          config {\n            span\n          }\n          elements {\n            __typename\n            ...useLayoutServiceHeadingElementData\n            ...useLayoutServiceParagraphElementData\n            ...useLayoutServiceSearchElementData\n            ...useLayoutServiceImageElementData\n            ...useLayoutServiceLinkCardElementData\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          visualConfig {\n            ...useLayoutServiceVisualConfigData\n          }\n          id\n        }\n        visualConfig {\n          ...useLayoutServiceVisualConfigData\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useLayoutServiceHeadingElementData on HelpLayoutHeadingAtomicElement {\n  headingConfig: config {\n    headingType\n    text\n  }\n  visualConfig {\n    ...useLayoutServiceVisualConfigData\n  }\n}\n\nfragment useLayoutServiceImageElementData on HelpLayoutImageAtomicElement {\n  __typename\n  imageConfig: config {\n    altText\n    fileId\n    size\n  }\n  data {\n    imageUrl\n  }\n  visualConfig {\n    ...useLayoutServiceVisualConfigData\n  }\n}\n\nfragment useLayoutServiceLinkCardElementData on HelpLayoutLinkCardCompositeElement {\n  linkCardConfig: config\n  children {\n    __typename\n    __isHelpLayoutAtomicElement: __typename\n    ...useLayoutServiceHeadingElementData\n    ...useLayoutServiceImageElementData\n    ...useLayoutServiceParagraphElementData\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useLayoutServiceParagraphElementData on HelpLayoutParagraphAtomicElement {\n  paragraphConfig: config {\n    adf\n  }\n  visualConfig {\n    ...useLayoutServiceVisualConfigData\n  }\n}\n\nfragment useLayoutServiceSearchElementData on HelpLayoutSearchAtomicElement {\n  __typename\n  searchConfig: config {\n    placeHolderText\n  }\n}\n\nfragment useLayoutServiceVisualConfigData on HelpLayoutVisualConfig {\n  alignment {\n    horizontalAlignment\n    verticalAlignment\n  }\n  backgroundImage {\n    fileId\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "55ba695159f4f1535abf2b4329a53088";

export default node;
